// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4327ecf5","732":"4eb5bcae","977":"219f5f58"}[chunkId] + ".chunk.js";
};